import { createContext } from 'react';

import { ThemeModeContext as NativeThemeModeContext } from '@libs/theme';

export const ThemeModeContext = createContext<NativeThemeModeContext>(
  {} as NativeThemeModeContext
);

export const ThemeModeProvider = ThemeModeContext.Provider;
